import React from 'react';
import styles from './Card.module.sass';

const Card = ({
    children
}: Props) => {
    
    return <div className={styles['card']}>
        { children }
    </div>;
}

interface Props {
    children: any
}

export default Card;